import React from 'react';
import { useIntl } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CreateFutrliTemplateWizardContainer } from './create-futrli-template-wizard-container';

interface CreateFutrliTemplateSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateFutrliTemplateSidebar = ({ isOpen, onClose }: CreateFutrliTemplateSidebarProps) => {
  const intl = useIntl();

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          {intl.formatMessage({
            id: 'reporting.create_a_futrli_template',
            defaultMessage: 'Create a Futrli template'
          })}
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
    >
      {isOpen && <CreateFutrliTemplateWizardContainer onClose={onClose} />}
    </Sidebar>
  );
};
